import { StatPill } from '../trainer/StatPill';

interface WeeklyProgressProps {
  workoutStreak: number;
  upcomingCount: number;
  completedCount: number;
  totalSessions: number;
}

export function WeeklyProgress({
  workoutStreak,
  upcomingCount,
  completedCount,
  totalSessions,
}: WeeklyProgressProps) {
  return (
    <div className="grid sm:grid-cols-4 gap-3">
      <StatPill label="Streak" value={workoutStreak} />
      <StatPill label="Upcoming" value={upcomingCount} />
      <StatPill label="Completed" value={completedCount} />
      <StatPill label="Total Sessions" value={totalSessions} />
    </div>
  );
}
